import React, { useMemo } from "react";
import { motion } from "framer-motion";
import getScrollAnimation from "@utils/getScrollAnimation";
import ScrollAnimationWrapper from "@components/layout/ScrollAnimationWrapper";
import { useNavigate } from "react-router-dom";
import home_image from "@assets/images/zyntegrate-infographic.png"
import { generateGuid } from "@utils/utils";
import { selectUserInfo } from "@redux/slices/authSlice";
import { useSelector } from "react-redux";

import Features from "./Features";

const Hero = () => {
  const scrollAnimation = useMemo(() => getScrollAnimation(), []);
  const navigate = useNavigate();
  const userInfo = useSelector(selectUserInfo);

  const handleGetStarted = () => navigate("/integrations/listing");

  const gotoAddItem = () => {
    var newGuid = generateGuid();
    navigate(`/integrations/${newGuid}/overview`); // Navigate to the next page
    //router.push("/add-integration/overview"); // Navigates to the /about page
  };

  if (!userInfo) {
    return (
      <>
        <Features />
      </>
    );
  }

  return (
    <>
      {/* Hero Section */}
      <div className="flex h-full min-h-0 overflow-hidden bg-white text-gray-900 relative flex-col">

        {/* Content */}
        <div className="relative flex flex-1 flex-col lg:flex-row items-center justify-between px-4 sm:px-8 lg:px-16 py-12 sm:py-16 gap-10 sm:gap-12 w-full mx-auto overflow-hidden">
          {/* Left Text Section */}
          <ScrollAnimationWrapper className="z-10 w-full lg:w-1/2">
            <motion.div
              className="text-center lg:text-left"
              variants={scrollAnimation}
            >
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight bg-gradient-to-r from-blue-600 to-indigo-700 bg-clip-text text-transparent uppercase tracking-wide">
                Zyntegrate
              </h1>
              <p className="mt-4 text-lg sm:text-xl text-gray-800 font-medium">
                Powerful AI Integrations. Faster, Smarter, Unified.
              </p>
              <p className="mt-3 text-base sm:text-lg text-gray-800">
                Enter your integration details <span className="font-semibold text-gray-900">Zyntegrate</span> connects them instantly with AI-powered precision
                {/* <span className="font-semibold text-white">Zyntegrate</span> will
                connect them effortlessly. */}
              </p>

              <div className="flex flex-col sm:flex-row justify-center lg:justify-start mt-8 gap-4 sm:gap-10">
                <button
                  onClick={handleGetStarted}
                  className="bg-[#f0f7ff] border border-[#cce3ff] text-[#1e3a8a] font-black px-8 py-3 rounded-full shadow-lg transition-all duration-300 hover:bg-[#e0efff] hover:border-[#b8d9ff] hover:shadow-blue-200/50 active:scale-95 tracking-wider text-sm"
                >
                  Start Monitoring
                </button>
                {userInfo && userInfo.role && userInfo.role.toLowerCase() !== "user" && (
                  <button
                    onClick={() => navigate("/launch-builder")}
                    className="bg-[#f0f7ff] border border-[#cce3ff] text-[#1e3a8a] font-black px-8 py-3 rounded-full shadow-lg transition-all duration-300 hover:bg-[#e0efff] hover:border-[#b8d9ff] hover:shadow-blue-200/50 active:scale-95 tracking-wider text-sm"
                  >
                    Launch Builder
                  </button>
                )}
              </div>
            </motion.div>
          </ScrollAnimationWrapper>

          <div className="relative w-full sm:max-w-lg z-10">
            <div className="absolute inset-0 bg-gradient-radial from-orange-500/30 via-transparent to-transparent opacity-80 blur-3xl z-0 rounded-full pointer-events-none scale-125" />
            <img
              src={home_image}
              alt="Zyntegrate Infographic"
              className="relative w-full h-auto z-10"
            />
          </div>
        </div>
      </div>

      {/* <Features /> */}
    </>
  );
};

export default Hero;